// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Israel from '../_raw/flag/icon_flag_israel.png';

export default () => <img src={Israel} alt="Israel" />;
